<template>
	<div class="home">
		<div class="main-panel">
			<div class="content">
				<div class="panel-header bg-primary-gradient">
					<div class="page-inner py-5">
						<div class="d-flex align-items-left align-items-md-center flex-column flex-md-row">
							<div>
								<h2 class="text-white pb-2 fw-bold">Inventaris P2L</h2>
							</div>
							<div class="ml-md-auto py-2 py-md-0">
								<div class="form-group">
									<div class="input-group">
										<input v-model="cari_value" @keyup="cari_data()" type="text" class="form-control" placeholder="Cari data ...">
										<div class="input-group-append">
											<button class="btn btn-primary" type="button" title="Tambah Data" data-toggle="modal" data-target="#m_add_data"><i class="fas fa-plus"></i></button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

<!-- <h1>TES1</h1>


<pdf src="https://crossorigin.me/http://36.89.95.163:5100/uploads/peraturan/1564543467109.pdf"></pdf>
<h1>TES2</h1> -->

				<div class="page-inner mt--5">
					<!-- <h1>asdfad</h1> -->
					<div class="table-responsive" style="background:white; overflow-x:auto;">


                        <table class="table-kiken table table-head-bg-info" width="100%" >
                            <thead>
                                <tr class="bg-primary">
                                    <th scope="col" style="width: 5%">No</th>

									<th scope="col" style="width: 15%">KWT</th>
                                    <th scope="col" style="width: 10%">Nama Ketua</th>
                                    <th scope="col" style="width: 15%">Desa/Kecamatan</th>
                                    <th scope="col" style="width: 10%">Sumber Anggaran</th>
                                    <th scope="col" style="width: 10%">Jml Anggaran</th>
                                    <th scope="col" style="width: 5%">Thn</th>
                                    <th scope="col" style="width: 20%">Ket</th>
                                    <th scope="col" style="width: 10%" class="text-center">
                                        <button @click="getPrint()" class="btn btn-primary" type="button" title="Cetak Data" data-toggle="modal" data-target="#m_lihat_data"><i class="fas fa-print"></i></button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="cek_load_data">
                                    <td colspan="9" class="text-center">
                                        <img src="img/loading-plan.gif" width="450px">
                                    </td>
                                </tr>
                                <template v-if="!cek_load_data" >
                                    <tr class="h_isitable" v-for="(data, index ) in list_data" :key="data.provinsi_id">
                                        <td class="text-center">{{index+1}}</td>
                                        <td class="">{{data.nama}}</td>
                                        <td class="">{{data.kelompok}}</td>
                                        <td>
                                            <!-- {{data.alamat}} <br> -->
                                            <span class="subTitle">Desa. {{data.nama_des_kel}} KEC. {{data.nama_kecamatan}}</span>
                                        </td>
                                        <td class="">{{data.sumber}}</td>
                                        <td class="">{{data.jml}}</td>
                                        <td class="text-center">{{data.tahun}}</td>
                                        <td>{{data.ket}}</td>
                                        <td class="text-center">
                                            <!-- <a @click="ke_alamat(data.isi)" class="btn btn-info btn-icon btn-round btn-xs" title="Menuju ke halaman sistem" data-toggle="modal"><i style="color:white" class="fas fa-play-circle"></i></a>
                                            &nbsp; -->
                                            <button @click="selectData(data), Addedit=true" class="btn btn-warning btn-icon btn-round btn-xs" title="Edit Data" data-toggle="modal" data-target="#m_edit_data"><i class="fas fa-pencil-alt"></i></button>
                                            &nbsp;
                                            <button @click="removeData(data.inventarisp2l_id )" class="btn btn-danger btn-icon btn-round btn-xs" title="Hapus Data"><i class="fas fa-trash-alt"></i></button>

                                        </td>
                                    </tr>
                                </template>


                            </tbody>
                        </table>

                        <hr>
                            <div class="text-center">
                                <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                                    <img src="assets/img/sf/sign-left.svg" height="24" width="24">
                                </button>
                                &nbsp;
                                <span style="font-size: 85%; color: #a5a5a5">
                                    <b>{{page_first}} - {{page_last}}</b>
                                </span>
                                &nbsp;
                                <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                                    <img src="assets/img/sf/sign-right.svg" height="24" width="24">
                                </button>
                            </div>
                        <hr>



					</div>

				</div>




                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_add_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-info">
                                    <h5 class="modal-title">TAMBAH DATA</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form @submit.prevent="addData()">
                                    <div class="modal-body">


                                        <span class="huruf_input">Nama Anggota</span>
                                        <autocomplete
                                            :url="ADD_URL_ANGGOTA_KWT+ 'autocomplete'"
                                            :customHeaders="{authorization: 'kikensbatara '+token }"
                                            anchor="nama"
                                            :initValue="form.anggota_id"
                                            :placeholder="'Cari Nama Ketua'"
                                            :classes="{ input: 'form-control form-control-sm'}"
                                            label="writer"
                                            :onShouldRenderChild="renderChild"
                                            :on-select="getAuto">
                                        </autocomplete>
                                        <br>

                                        <span class="huruf_input">Jml Anggaran</span>
                                        <input v-model="form.jml" type="number" class="form-control form-control-sm"> <br>

                                        <span class="huruf_input">Sumber</span>
                                        <select @change="getTahun()" class="form-control" v-model="form.master_sumber_id">
                                            <option v-for="data in list_sumber" :key="data.master_sumber_id " :value="data.master_sumber_id ">{{data.sumber}}</option>
                                        </select>
                                


                                        <span class="huruf_input">Tahun</span>
                                        <select @change="getTahun()" class="form-control" v-model="form.tahun">
                                            <option v-for="data in list_thn" :key="data.id" :value="data.id">{{data.tahun}}</option>
                                        </select>



                                        <span class="huruf_input">Keterangan</span>
                                        <textarea v-model="form.ket" class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>

                                        




                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn bgcol-info btn-md">SIMPAN</button>
                                        <button type="button" class="btn bgcol-danger btn-md" data-dismiss="modal">BATAL</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-warning">
                                    <h5 class="modal-title">EDIT DATA</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form @submit.prevent="editData()">
                                    <div class="modal-body">

                                        <span class="huruf_input">Nama Anggota</span>
                                        <autocomplete
                                            :url="ADD_URL_ANGGOTA_KWT+ 'autocomplete'"
                                            :customHeaders="{authorization: 'kikensbatara '+token }"
                                            anchor="nama"
                                            :initValue="form.anggota_id"
                                            :placeholder="nama"
                                            :classes="{ input: 'form-control form-control-sm'}"
                                            label="writer"
                                            :onShouldRenderChild="renderChild"
                                            :on-select="getAuto">
                                        </autocomplete>
                                        <br>

                                        <span class="huruf_input">Jml Anggaran</span>
                                        <input v-model="form.jml" type="number" class="form-control form-control-sm"> <br>

                                        <span class="huruf_input">Sumber</span>
                                        <input v-model="form.master_sumber_id" type="text" class="form-control form-control-sm"> <br>


                                        <span class="huruf_input">Tahun</span>
                                        <select @change="getTahun()" class="form-control" v-model="form.tahun">
                                            <option v-for="data in list_thn" :key="data.id" :value="data.id">{{data.tahun}}</option>
                                        </select>



                                        <span class="huruf_input">Keterangan</span>
                                        <textarea v-model="form.ket" class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>

                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn bgcol-warning btn-md">Edit</button>
                                        <button type="button" @click="Addedit=false" class="btn bgcol-danger btn-md" data-dismiss="modal">Batal</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->  
                    <div class="modal fade" id="m_lihat_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-xl mdl-lgz" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-header">
                                    <h5 class="modal-title">DATA DETIL</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <button @click="print()" class="btn btn-sm" style="background:#32C4D8; color:white">Print <span style="font-size:14px">🖨</span></button>
                                    <div id="printMe">
                                        <div class="text-center" style="font-size:14px; font-weight:bold">
                                            DAFTAR INVENTARIS P2L DINAS KETAHANAN PANGAN KABUPATEN KONAWE SELATAN
                                        </div>
                                            <br>
                                        <div class="table-responsive">
                                            <table class="table-kiken table table-head-bg-info" width="100%" >
                                                <thead>
                                                    <tr class="bg-primary">
                                                        <th scope="col" style="width: 5%">No</th>

                                                        <th scope="col" style="width: 15%">Nama KWT</th>
                                                        <th scope="col" style="width: 10%">Nama Ketua</th>
                                                        <th scope="col" style="width: 15%">Desa</th>
                                                        <th scope="col" style="width: 15%">Kecamatan</th>
                                                        <th scope="col" style="width: 10%">Sumber Anggaran</th>
                                                        <th scope="col" style="width: 10%">Jml Anggaran</th>
                                                        <th scope="col" style="width: 5%">Thn</th>
                                                        <th scope="col" style="width: 20%">Ket</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="cek_load_data">
                                                        <td colspan="9" class="text-center">
                                                            <img src="img/loading-plan.gif" width="450px">
                                                        </td>
                                                    </tr>
                                                    <template v-if="!cek_load_data" >
                                                        <tr class="h_isitable" v-for="(data, index ) in list_print" :key="data.provinsi_id+index">
                                                            <td class="text-center">{{index+1}}</td>
                                                            <td class="">{{data.kelompok}}</td>
                                                            <td class="">{{data.nama}}</td>
                                                            <td>{{data.nama_des_kel}} </td>
                                                            <td class="">{{data.nama_kecamatan}}</td>
                                                            <td class="text-center">{{data.sumber}}</td>
                                                            <td class="">{{data.jml}}</td>
                                                            <td class="text-center">{{data.tahun}}</td>
                                                            <td>{{data.ket}}</td>
                                                        </tr>
                                                    </template>


                                                </tbody>
                                            </table>

                                        </div>

                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn bgcol-danger btn-md" data-dismiss="modal">Keluar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->




			</div>


		<!-- Footer -->
			<foother></foother>
			<!-- End Footer -->


		</div>
	</div>
</template>

<script>



const ADD_URL = URL_APP + "api/v1/iventarispl/";
const ADD_URL_ANGGOTA_KWT = URL_APP + "api/v1/anggota_kwt/";
const ADD_URL_DATE = URL_APP + "api/v1/statistik_ketapang_master_thn_bln/";
const ADD_URL_SUMBER = URL_APP + "api/v1/sumber/";
const FILE_LOAD = URL_APP + "uploads/";

import Autocomplete from 'vue2-autocomplete-js';



export default {
    components: { Autocomplete },

    data() {
        return {
            data_load : false,
            form : {
                inventarisp2l_id  : '',
                anggota_id  : '',
                master_sumber_id  : '',
                jml : '',
                tahun  : '',
                ket : '',
            },
            id :'',
            cek_load_data : true,
            file_old: "",
            file_path: FILE_LOAD,

            list_data: [],
            list_thn : [],
            list_sumber : [],
            list_print: [],
            page_first: 1,
            page_last: 0,
            cari_value: "",

            nama : '',

            ADD_URL_ANGGOTA_KWT : ADD_URL_ANGGOTA_KWT,
            token : localStorage.token,

            Addedit : false,
        }
    },
    methods: {
        getView: function() {
            this.cek_load_data = true;
            fetch(ADD_URL + "view", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    data_ke: this.page_first,
                    cari_value: this.cari_value
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    console.log(res_data);
                this.list_data = res_data.data;
                this.page_last = res_data.jml_data;
                this.cek_load_data = false;
            });
        },

        addData: function() {

            fetch(ADD_URL + "addData", {
                method: "POST",
                headers: {
                    'content-type' : 'application/json',
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.form)
            }).then(res_data => {
                this.alertku("success", "sukses menambah data");
                this.getView();
            });
        },

        editData: function() {

            fetch(ADD_URL + "editData", {
                method: "POST",
                headers: {
                    'content-type' : 'application/json',
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.form)
            }).then(res_data => {
                this.alertku("success", "Sukses merubah data");
                this.getView();
            });
        },

        selectData: function(data) {
            console.log(data);

                this.form.inventarisp2l_id  = data.inventarisp2l_id;
                this.form.anggota_id  = data.anggota_id;
                this.form.master_sumber_id  = data.master_sumber_id;
                this.form.jml = data.jml;
                this.form.tahun  = data.tahun;
                this.form.ket = data.ket;

                this.nama = data.nama
        },


        removeData: function(idnya) {
            fetch(ADD_URL + "removeData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                    body: JSON.stringify({
                    inventarisp2l_id : idnya,
                })
            }).then(res_data => {
                this.getView();
                this.alertku("success", "sukses menghapus data");
                this.fileku = null;
            });
        },

        ke_alamat : function(data){
            window.open(data);
        },


        getPrint: function() {
            this.cek_load_data = true;
            fetch(ADD_URL + "", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    data_ke: '',
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    // console.log(res_data);
                    this.list_print = res_data;
                    // console.log(res_data);
                    this.cek_load_data = false;

            });
        },


    // ================== PAGINASI ====================
        alertku: function(type, title) {
            this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
            });
        },

        btn_prev : function(){
                this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){

            this.page_first = 1;
            this.getView();
        },

        onFileSelected: function(event) {
            this.form.file = event.target.files[0];
        },
        convert_tgl: function(dateString) {
            var date = new Date(dateString);
            var getBulan = date.getMonth() + 1; var bulan = '';
            if (getBulan == '1') {bulan = 'Jan'} 
            else if(getBulan == '2') {bulan = 'Feb'}
            else if(getBulan == '3') {bulan = 'Mar'}
            else if(getBulan == '4') {bulan = 'Apr'}
            else if(getBulan == '5') {bulan = 'Mei'}
            else if(getBulan == '6') {bulan = 'Jun'}
            else if(getBulan == '7') {bulan = 'Jul'}
            else if(getBulan == '8') {bulan = 'Agt'}
            else if(getBulan == '9') {bulan = 'Sep'}
            else if(getBulan == '10') {bulan = 'Okt'}
            else if(getBulan == '11') {bulan = 'Nov'}
            else if(getBulan == '12') {bulan = 'Des'}

            return date.getDate() + " " + bulan + " " + date.getFullYear();
            // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
        },

        getTahun : function(){
            fetch(ADD_URL_DATE + "thn", {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }            
            })
            .then(res => res.json())
            .then(res_data => {

                 this.list_thn = res_data;
            });
        },

        getSumber : function(){
            fetch(ADD_URL_SUMBER + "", {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }            
            })
            .then(res => res.json())
            .then(res_data => {

                 this.list_sumber = res_data;
                 console.log(res_data);
            });
        },

        print () {
        // Pass the element id here
        this.$htmlToPaper('printMe');
        },

         // ================== AUTOCOMPLETE ====================
        renderChild(data) {
            return `
            <span><b>${'Kelompok '+data.nama}</b></span>
            <span style='font-size:90%'>${data.kelompok}</span>
            <span style='font-size:80%'>${data.nama_des_kel}</span>
            `
        },
        getAuto : function(obj){
            this.form.anggota_id = obj.anggota_id;
            // this.getView();
            console.log(obj);
        },
    // ================== AUTOCOMPLETE ====================


        
    },
    mounted() {
        var get_profile = JSON.parse(localStorage.profile);
        // this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
        this.form.unit_kerja = get_profile.profile.unit_kerja;

        this.getTahun();
        this.getSumber();
        var d = new Date();
        // console.log(d.getMonth())
        this.form.tahun = toString(d.getFullYear());

        this.getView();


    },

}
</script>